export const LanguageConstant = {
    LOCALSTORAGE : 'DefaultLanguage',
}